import React from "react";
import AsyncAutoComplete from "components/shared/asyncAutoComplete";
import styles from "../Tasks.module.scss";
import { useLocationOptions } from "components/hooks/useLocationOption";

export const LocationFilterContainer = ({ onSelectedLocation, label = "Location", placeholder = "Location",customStyles, height = "auto", width = 220, defaultValue }) => {
  const { onSelectedOptionChange, ...options } = useLocationOptions();

  const onSelectedLocationptionChange = (event, newValue) => {
    onSelectedLocation(newValue);
  };

  return (
    <div className={styles.teamFilterContainer}>
      <AsyncAutoComplete
        label={label}
        placeholder={placeholder}
        width={width}
        height={height}
        defaultValue={defaultValue}
        onSelectedOptionChange={onSelectedLocationptionChange}
        customStyles={customStyles}
        {...options}
      />
    </div>
  );
};
